import { render, staticRenderFns } from "./rejectClaimantBill.vue?vue&type=template&id=56d0ead9&scoped=true&"
import script from "./rejectClaimantBill.vue?vue&type=script&lang=js&"
export * from "./rejectClaimantBill.vue?vue&type=script&lang=js&"
import style0 from "./rejectClaimantBill.vue?vue&type=style&index=0&id=56d0ead9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d0ead9",
  null
  
)

export default component.exports